//@flow
import React from "react";
import {
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Colors from "@microdoing/shared/constants/Colors";
import Theme from "@microdoing/shared/constants/Theme";
import { Loading } from "./Loading";
import theme from "app/Theme/Theme";

type Props = {
  onPressDisabled?: () => mixed;
  onPress: () => mixed;
  onPressIn?: () => mixed;
  delayPressIn?: number;
  text: string;
  testID?: string;
  isDisabled?: Boolean;
  buttonPropStyle?: {};
  textPropStyle?: {};
  requesting?: boolean;
  Icon?: any;
  // type: string // light or plain
};

const CardButton = ({
  testID,
  isDisabled,
  onPressDisabled,
  onPress,
  onPressIn,
  delayPressIn,
  text,
  buttonPropStyle,
  textPropStyle,
  requesting = false,
  Icon = null,
}: Props) => {
  let { buttonStyle, textStyle } = styles;
  buttonStyle = buttonPropStyle
    ? { ...buttonStyle, ...buttonPropStyle }
    : buttonStyle;
  textStyle = textPropStyle ? { ...textStyle, ...textPropStyle } : textStyle;

  if (requesting) {
    return (
      <View style={[styles.requesting, buttonStyle]}>
        <Loading size={25} />
      </View>
    );
  } else if (isDisabled) {
    return (
      <TouchableWithoutFeedback onPress={onPressDisabled} testID={testID}>
        <View
          style={{
            ...buttonStyle,
            backgroundColor: theme.colors["neutral.400"],
          }}
        >
          {Icon}
          <Text style={[textStyle, { color: "#A8A9B7", fontWeight: "normal" }]}>
            {text}
          </Text>
        </View>
      </TouchableWithoutFeedback>
    );
  }

  return (
    <TouchableOpacity
      onPress={onPress}
      style={buttonStyle}
      testID={testID}
      onPressIn={onPressIn}
      delayPressIn={delayPressIn}
    >
      {Icon}
      <Text style={[{ marginLeft: Icon ? 8 : 0 }, textStyle]}>{text}</Text>
    </TouchableOpacity>
  );
};

const styles = {
  buttonStyle: {
    height: 40,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    backgroundColor: theme.colors["brand.500"],
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  textStyle: {
    color: "white",
    fontSize: Theme.FONT_SIZE_MEDIUM,
    fontWeight: "bold",
  },
  requesting: {
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: 50,
    backgroundColor: Colors.lightMain,
  },
};

export { CardButton };
